import { RefObject } from 'react';
import { Input } from 'taxaroo-ui';

const { Search } = Input;

interface SearchBarProps {
  disabled: boolean;
  searchRef: RefObject<HTMLInputElement>;
  setSearchedValue: (value: string) => void;
  searchBarValue: string;
  setSearchBarValue: (value: string) => void;
  // eslint-disable-next-line react/require-default-props
  prefix?: JSX.Element;
}

const SearchBar = ({
  disabled,
  searchRef,
  setSearchedValue,
  searchBarValue,
  setSearchBarValue,
  prefix,
}: SearchBarProps) => {
  const handleSearch = (v: string) => {
    setSearchedValue(v);
  };
  return (
    <Search
      ref={searchRef}
      placeholder="Search by name, email, phone (numbers only), or tax year"
      onSearch={handleSearch}
      disabled={disabled}
      value={searchBarValue}
      onChange={(e) => setSearchBarValue(e.target.value)}
      addonBefore={prefix}
    />
  );
};

export default SearchBar;
